import { formatDistanceToNow } from 'date-fns';

interface FormattedDateProps {
  date: string | Date | null | undefined;
  addSuffix?: boolean;
  className?: string;
}

/**
 * Display a humanized relative date with ISO timestamp tooltip
 *
 * @example
 * <FormattedDate date={job.create_ts} addSuffix />
 * // Shows: "2 hours ago" with tooltip: "2025-10-23T21:30:45.123Z"
 */
export default function FormattedDate({ date, addSuffix = true, className = '' }: FormattedDateProps) {
  // Handle null/undefined dates
  if (!date) {
    return <span className={className}>-</span>;
  }

  const dateObj = typeof date === 'string' ? new Date(date) : date;

  // Handle invalid dates
  if (isNaN(dateObj.getTime())) {
    return <span className={className}>Invalid date</span>;
  }

  const isoString = dateObj.toISOString();
  const relativeTime = formatDistanceToNow(dateObj, { addSuffix });

  return (
    <span
      className={`cursor-help border-b border-dotted border-muted-foreground/40 ${className}`}
      title={isoString}
    >
      {relativeTime}
    </span>
  );
}
